import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

class MeasureUnitSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      name: 'measureUnit',
      title: 'Unidade de medida',
      label: 'name',
      url: 'ton/v1/unity-types'
    };
  }

}

MeasureUnitSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default MeasureUnitSelector;

/* Valores baseados na tabela de unidade de medida da NFE  05/07/2016


AMPOLA    AMPOLA
BALDE    BALDE
BANDEJ    BANDEJA
BARRA    BARRA
BISNAG    BISNAGA
BLOCO    BLOCO
BOBINA    BOBINA
BOMB    BOMBONA
CAPS    CAPSULA
CART    CARTELA
CENTO    CENTO
CJ    CONJUNTO
CM    CENTIMETRO
CM2    CENTIMETRO QUADRADO
CX    CAIXA
CX2    CAIXA COM 2 UNIDADES
CX3    CAIXA COM 3 UNIDADES
CX5    CAIXA COM 5 UNIDADES
CX10    CAIXA COM 10 UNIDADES
CX15    CAIXA COM 15 UNIDADES
CX20    CAIXA COM 20 UNIDADES
CX25    CAIXA COM 25 UNIDADES
CX50    CAIXA COM 50 UNIDADES
CX100    CAIXA COM 100 UNIDADES
DISP    DISPLAY
DUZIA    DUZIA
EMBAL    EMBALAGEM
FARDO    FARDO
FOLHA    FOLHA
FRASCO    FRASCO
GALAO    GALÃO
GF    GARRAFA
GRAMAS    GRAMAS
JOGO    JOGO
KG    QUILOGRAMA
KIT    KIT
LATA    LATA
LITRO    LITRO
M    METRO
M2    METRO QUADRADO
M3    METRO CÚBICO
MILHEI    MILHEIRO
ML    MILILITRO
MWH    MEGAWATT HORA
PACOTE    PACOTE
PALETE    PALETE
PARES    PARES
PC    PEÇA
POTE    POTE
K    QUILATE
RESMA    RESMA
ROLO    ROLO
SACO    SACO
SACOLA    SACOLA
TAMBOR    TAMBOR
TANQUE    TANQUE
TON    TONELADA
TUBO    TUBO
UNID    UNIDADE
VASIL    VASILHAME
VIDRO    VIDRO */



// WEBPACK FOOTER //
// ./src/productType/component/MeasureUnitSelector.js